'use client';

import { Grid2, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import trustedMapImage from '@/assets/materials/orbit/trusted-map-image.png';

const STATS = [
  { value: '3,000+', label: 'Organizations supported' },
  { value: '7,000+', label: 'Professionals onboarded' },
  { value: '180+', label: 'Countries covered' },
  { value: '70+', label: 'Currencies supported' },
];

export const TrustedSection = () => {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', sm: '40px', md: '80px' }}
      paddingY={{ xs: '32px', sm: '50px', md: '80px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}
      sx={{ background: '#060912' }}>
      <Stack gap={{ xs: 5, sm: 7, md: 10 }} width={'min(1280px, 100%)'} zIndex={2}>
        {/* Title */}
        <Stack alignItems={'center'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            fontSize={{ xs: '20px', sm: '28px', md: '36px' }}
            lineHeight={{ xs: '24px', sm: '36px', md: '48px' }}
            textAlign={'center'}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            TRUSTED AT GLOBAL SCALE
          </Typography>
        </Stack>

        {/* Stats and Image */}
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          gap={{ xs: 4, sm: 6, md: 10 }}
          width={'100%'}
          alignItems={'center'}>
          {/* Stats Grid */}
          <Grid2 container spacing={{ xs: 2, sm: 3, md: 5 }} width={'100%'} flex={1}>
            {STATS.map((stat, index) => (
              <Grid2 size={{ xs: 6, sm: 6 }} key={index}>
                <Stack alignItems={'center'} gap={1}>
                  <Typography
                    fontSize={{ xs: '32px', sm: '40px', md: '48px' }}
                    lineHeight={{ xs: '40px', sm: '54px', md: '68px' }}
                    fontWeight={700}
                    color={'#7296FF'}
                    textAlign={'center'}>
                    {stat.value}
                  </Typography>
                  <Typography
                    fontSize={{ xs: '14px', sm: '16px', md: '18px' }}
                    variant={'bodyLarge'}
                    color={'#FFFFFF'}
                    textAlign={'center'}>
                    {stat.label}
                  </Typography>
                </Stack>
              </Grid2>
            ))}
          </Grid2>

          {/* Map Image */}
          <Stack
            width={{ xs: '100%', sm: '100%', md: '620px' }}
            height={{ xs: '196px', sm: '280px', md: '370px' }}
            position={'relative'}
            sx={{ flexShrink: 0 }}>
            <Image
              src={trustedMapImage}
              alt={'Global coverage map'}
              fill
              style={{ objectFit: 'cover', borderRadius: '8px' }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
